import { env } from '@/utils/env';
import { wordpressClient } from '../common/wordpressClient';
import type { GetCookieUserResponse } from './utils/types';

class UserAPIClient {
  async getCookieUser(): Promise<GetCookieUserResponse> {
    if (env('NEXT_PUBLIC_ENV') === 'LOCAL') {
      return null;
    }
    try {
      const res = await wordpressClient.get('/wp-json/skinseoul/v1/cookie-user');
      const response = await res.json();
      return response;
    } catch (e: unknown) {
      if (e instanceof Response && (e.status === 401 || e.status === 403)) {
        return null;
      }
      return null;
    }
  }
}

export const userAPIClient = new UserAPIClient();
